module.exports = __webpack_public_path__ + "static/media/terminal.67a528c5.jpg";